import { atom } from "jotai";

export const sesionesAtom = atom([]);
export const loadingAtom = atom(false);